import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../app/store";
import { loginViaOAuth } from "../../../models/users/myUserSlice";
import { getDecisionStatuses } from "../../../models/organization/organizationSlice";
import { getOAuthClient } from "../../../utils/oauth";
import { OAuthLoadingScreen } from "../../../components/OAuthLoadingScreen";

const OAuthCallback: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const orgSlug = window.location.pathname.split("/")[2]; // Extract from /organization/{slug}/...

      try {
        if (!getOAuthClient().isCallback()) {
          // Not an OAuth callback, redirect to login
          history.push("login");
          return;
        }

        // Process OAuth callback
        const result: any = await dispatch(loginViaOAuth());

        if (result.error) {
          throw new Error(result.error.message || "OAuth login failed");
        }

        // Load decision statuses after successful OAuth login
        await dispatch(getDecisionStatuses(orgSlug));

        // Success - redirect to applications overview page
        history.push("applications/overview");
      } catch (error) {
        console.error("OAuth callback failed:", error);

        // Redirect to login with error
        let org = "";
        const matches = window.location.pathname.match(/organization\/(.*)\//);
        if (matches) org = matches[1];
        const redirectUrl = `/organization/${org.split("/")[0]}/login-error`;
        window.location.replace(redirectUrl);
      }
    };

    handleOAuthCallback();
  }, [dispatch, history]);

  return <OAuthLoadingScreen />;
};

export default OAuthCallback;
